"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAssetTranslationMappingResponseToJSON = exports.SurveyAssetTranslationMappingResponseFromJSONTyped = exports.SurveyAssetTranslationMappingResponseFromJSON = exports.instanceOfSurveyAssetTranslationMappingResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyAssetTranslationMappingResponse interface.
 */
function instanceOfSurveyAssetTranslationMappingResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyAssetTranslationMappingResponse = instanceOfSurveyAssetTranslationMappingResponse;
function SurveyAssetTranslationMappingResponseFromJSON(json) {
    return SurveyAssetTranslationMappingResponseFromJSONTyped(json, false);
}
exports.SurveyAssetTranslationMappingResponseFromJSON = SurveyAssetTranslationMappingResponseFromJSON;
function SurveyAssetTranslationMappingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'languageCode': !(0, runtime_1.exists)(json, 'language_code') ? undefined : json['language_code'],
        'audioAssetId': !(0, runtime_1.exists)(json, 'audio_asset_id') ? undefined : json['audio_asset_id'],
        'logoAssetId': !(0, runtime_1.exists)(json, 'logo_asset_id') ? undefined : json['logo_asset_id'],
        'companionAssetId': !(0, runtime_1.exists)(json, 'companion_asset_id') ? undefined : json['companion_asset_id'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'transparencyLink': !(0, runtime_1.exists)(json, 'transparency_link') ? undefined : json['transparency_link'],
        'transparencyLinkText': !(0, runtime_1.exists)(json, 'transparency_link_text') ? undefined : json['transparency_link_text'],
    };
}
exports.SurveyAssetTranslationMappingResponseFromJSONTyped = SurveyAssetTranslationMappingResponseFromJSONTyped;
function SurveyAssetTranslationMappingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'language_code': value.languageCode,
        'audio_asset_id': value.audioAssetId,
        'logo_asset_id': value.logoAssetId,
        'companion_asset_id': value.companionAssetId,
        'brand_name': value.brandName,
        'transparency_link': value.transparencyLink,
        'transparency_link_text': value.transparencyLinkText,
    };
}
exports.SurveyAssetTranslationMappingResponseToJSON = SurveyAssetTranslationMappingResponseToJSON;
